import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { useLocation, Link, useNavigate } from 'react-router-dom';

const ApexNavbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const isHomePage = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const goToApplication = () => {
    setIsMobileMenuOpen(false);
    navigate('/5k-guarantee#application');
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled
          ? 'bg-[#0A0A0A]/80 backdrop-blur-2xl border-b border-[#ffffff08]'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-6xl mx-auto px-6 md:px-12">
        <div className="flex items-center justify-between h-20">
          {/* Logo - minimal */}
          <Link to="/" className="flex items-center gap-3" data-testid="navbar-logo">
            <img
              src="/apex-icon.png"
              alt="Apex Growth"
              className="h-10 w-10 object-contain"
            />
            <span className="text-white font-semibold text-base hidden sm:block tracking-wide">
              Apex Growth
            </span>
          </Link>

          {/* Desktop Navigation - cleaner */}
          <div className="hidden md:flex items-center gap-10">
            <Link
              to="/5k-guarantee"
              className="text-[#A1A1AA] hover:text-white transition-colors text-sm"
            >
              £5K Guarantee
            </Link>
            <Link
              to="/pt-growth-academy"
              className="text-[#A1A1AA] hover:text-white transition-colors text-sm"
            >
              PT Academy
            </Link>
            <Link
              to="/lead-conversion"
              className="text-[#A1A1AA] hover:text-white transition-colors text-sm"
            >
              Lead Conversion
            </Link>
          </div>

          {/* CTA Button - minimal */}
          <div className="hidden md:block">
            <button
              onClick={goToApplication}
              data-testid="navbar-cta"
              className="bg-[#22C55E] hover:bg-[#1DB954] text-black font-medium rounded-full px-6 py-2.5 text-sm transition-all duration-300"
            >
              Get Started
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-white p-2"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            data-testid="mobile-menu-toggle"
          >
            {isMobileMenuOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>

        {/* Mobile Menu - cleaner */}
        {isMobileMenuOpen && (
          <div className="md:hidden bg-[#0A0A0A] border-t border-[#ffffff08] py-6">
            <div className="flex flex-col space-y-1">
              <Link
                to="/"
                className="text-[#A1A1AA] hover:text-white transition-colors px-4 py-3 text-sm"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Home
              </Link>
              <Link
                to="/5k-guarantee"
                className="text-[#A1A1AA] hover:text-white transition-colors px-4 py-3 text-sm"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                £5K Guarantee
              </Link>
              <Link
                to="/pt-growth-academy"
                className="text-[#A1A1AA] hover:text-white transition-colors px-4 py-3 text-sm"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                PT Academy
              </Link>
              <Link
                to="/lead-conversion"
                className="text-[#A1A1AA] hover:text-white transition-colors px-4 py-3 text-sm"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Lead Conversion
              </Link>
              <div className="px-4 pt-4">
                <button
                  onClick={goToApplication}
                  className="w-full bg-[#22C55E] text-black font-medium rounded-full px-6 py-3 text-sm transition-all"
                >
                  Get Started
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default ApexNavbar;
